import React from 'react';
import {Layout} from 'shared/components';
import {Display} from 'shared/components';
import {t} from 'shared/core';
import PayrollUpdatesList from './PayrollUpdatesList';

const PayrollUpdatesContainer = () => {
  return (
    <div>
      <Display title={t('payroll_updates.Payroll Updates')}/>
      <Layout>
        <PayrollUpdatesList/>
      </Layout>
    </div>
  );
};


export default PayrollUpdatesContainer;
